import React from 'react';
import Modal from '@mui/material/Modal';
import { ModalType } from './ModalType';
import Box from '@mui/material/Box';

function ModalComponent(props: ModalType) {
  const { onClose, open, children } = props;
  const handleClose = () => {
    return onClose();
  };
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '480px',
    bgcolor: '#ffffff',
    padding: '20px',
    borderRadius: '20px',
    backgroundColor: '#fff',
    overflowY: 'auto',
  };
  return (
    <Modal open={open} onClose={() => handleClose()}>
      <Box sx={style}>{children}</Box>
    </Modal>
  );
}

export default ModalComponent;
